import { Card } from "antd";
import { getChartReportV2, getTableReportV2 } from "api";
import { ColumnChart } from "components/chart/ChartDashboard";
import DashboardHeader from "components/dashboard-header/DashboardHeader";
import TableReport from "components/table/TableReport";
import { useState } from "react";
import ReportError from "components/chart/ReportError";
import useReportV2 from "utils/hooks/useReportV2";
import useDocumentTitle from "utils/useDocumentTitle";
import "./report.less";

const ReportEmail = () => {
  const headerCSVUser = [
    { label: "Tanggal", key: "date" },
    { label: "Domain", key: "domainName" },
    { label: "Email Terkirim", key: "countDelivered" },
    { label: "Email Gagal", key: "countFailed" },
    { label: "Total Email", key: "countSent" },
    { label: "Email Pengirim Terbanyak", key: "mostSender" },
    { label: "Email Penerima Terbanyak", key: "mostEmailReceiver" },
    { label: "Penerima Terbanyak", key: "mostDomainReceiver" },
  ];
  useDocumentTitle("Report Email");
  const [filter, setFilter] = useState({
    page: 1,
    limit: "10",
  });
  const history = useReportV2(getTableReportV2, filter);
  const monthly = useReportV2(getChartReportV2);
  const table = history.data;
  // Unknown historical ranking metadata stays unknown in exported rows too.
  const dataCSV = (table?.rows || []).map((row) =>
    Object.fromEntries(
      Object.entries(row).map(([key, value]) => [key, value === null ? "—" : value])
    )
  );

  return (
    <div className="report-email-user ">
      <DashboardHeader title="Report Email" />
      <div className="site-card-border-less-wrapper">
        <div className="px-6 py-4">
          <Card
            bordered={false}
            title="Pengiriman 12 bulan terakhir (WIB)"
            loading={monthly.loading}>
            {monthly.error ? (
              <ReportError error={monthly.error} retry={monthly.retry} />
            ) : (
              <ColumnChart data={monthly.data || []} />
            )}
          </Card>
          {history.error ? (
            <Card bordered={false} title="Email Delivery Report">
              <ReportError error={history.error} retry={history.retry} />
            </Card>
          ) : table ? (
            <div className="p-6 bg-white">
              <TableReport
                historyV2
                title={{
                  title: "Email Delivery Report",
                  pageLimit: {
                    isVisible: table.count > 10,
                    currentLimit: filter.limit,
                    onSelectLimit: (limit) => setFilter({ ...filter, limit, page: 1 }),
                    disable: table.count < 10,
                  },
                  buttonExport: {
                    dataCSV,
                    headerCSV: headerCSVUser,
                    responsive: "lg",
                    table: "invoice",
                    disable: !table.rows.length,
                  },
                }}
                filter={filter}
                setFilter={setFilter}
                responsive="xs"
                data={{ table, loading: history.loading }}
                emptyState={{ message: "Tidak ada laporan pengiriman email untuk halaman ini." }}
              />
            </div>
          ) : (
            <Card bordered={false} title="Email Delivery Report" loading={history.loading} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportEmail;
